{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "பாஸ்வேர்ட்",
      "PLACEHOLDER": "பாஸ்வேர்ட்",
      "ERROR": "Password is too short."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "பாஸ்வேர்டை உறுதிப்படுத்தவும்",
      "ERROR": "Passwords do not match."
    },
    "API": {
      "SUCCESS_MESSAGE": "Successfully changed the password.",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
    },
    "CAPTCHA": {
      "ERROR": "Verification expired. Please solve captcha again."
    },
    "SUBMIT": "சமர்பிக்கவும்"
  }
}
